import { Http } from '@/lib/http';

export class FieldVisitTriggersService extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/settings/field-visit-settings';
  }

  createFieldVisitTrigger(payload) {
    return this.httpClient().post(`${this.endpoint}`, payload);
  }

  fetchFieldVisitTriggers() {
    return this.httpClient().get(`${this.endpoint}`);
  }

  updateFieldVisitTrigger(id, updates) {
    return this.httpClient().put(`${this.endpoint}/${id}`, updates);
  }

  deleteFieldVisitTrigger(id) {
    return this.httpClient().delete(`${this.endpoint}/${id}`);
  }

  ensureDefaults(id) {
    return this.httpClient().patch(`${this.endpoint}/${id}/ensure-defaults`);
  }
}